import Layout from "../include/layout";
import { Badge, Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import EditButton from "../../components/editButtonComponent";
import EtablissementsService from "./EtablissementsService";
import Filarial from "../include/filarial";

export default function EtablissementIndex() {

    const activeLink = "ETABLISSEMENTS"

    const token = useSelector(state => state.auth.token)
    const [etablissements, setEtablissements] = useState([])
    const [idEtablissement, setIdEtablissement] = useState("")
    const [raisonsocialeEtablissement, setRaisonsocialeEtablissement] = useState("");
    const [sigleEtablissement, setSigleEtablissement] = useState("");
    const [dirigeantEtablissement, setDirigeantEtablissement] = useState("");
    const [telephoneprimaireEtablissement, setTelephoneprimaireEtablissement] = useState("");
    const [telephonesecondaireEtablissement, setTelephonesecondaireEtablissement] = useState("");
    const [emailEtablissement, setEmailEtablissement] = useState("");
    const [emailsupportEtablissement, setEmailSupportEtablissement] = useState("");
    const [adresseEtablissement, setAdresseEtablissement] = useState("");
    const [siteWeb, setSiteWeb] = useState("");
    const [boitePostale, setBoitePostale] = useState("");
    const [emailnotificationEtablissement, setEmailnotificationEtablissement] = useState("");
    const [fondateurEtablissement, setFondateurEtablissement] = useState("");
    const [signatureEtablissement, setSignatureEtablissement] = useState("");
    const [logoEtablissement, setLogoEtablissement] = useState("");

    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //get liste etablissements
    const fetchEtablissements = async () => {
        await EtablissementsService.index(token).then((res) => {
          //  console.log(res.data.data.etablissements)
            setEtablissements(res.data.data.etablissements)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.etablissements_edit, { state: { id: param } })
    }
    //Afficher le modal de détail user
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDetails = (id) => {
    const etablissement = etablissements.find((e) => e.id === id);
     const idEtablissement = etablissement.id

    // Mettez à jour l'état local avec les détails de l'enseignant spécifique
    setIdEtablissement(idEtablissement)
    setRaisonsocialeEtablissement(etablissement.raisonsocialeEtablissement)
    setSigleEtablissement(etablissement.sigleEtablissement)
    setDirigeantEtablissement(etablissement.dirigeantEtablissement)
    setTelephoneprimaireEtablissement(etablissement.telephoneprimaireEtablissement)
    setTelephonesecondaireEtablissement(etablissement.telephonesecondaireEtablissement)
    setEmailEtablissement(etablissement.emailEtablissement)
    setEmailSupportEtablissement(etablissement.emailsupportEtablissement)
    setEmailnotificationEtablissement(etablissement.emailnotificationEtablissement)
    setBoitePostale(etablissement.boitePostale)
    setSiteWeb(etablissement.siteWeb)
    setFondateurEtablissement(etablissement.fondateurEtablissement)
    setAdresseEtablissement(etablissement.adresseEtablissement)
    setSignatureEtablissement(etablissement.signatureEtablissement)
    setLogoEtablissement(etablissement.logoEtablissement)
    handleShow();
    };

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                EtablissementsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchEtablissements()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }


    useEffect(() => {
        fetchEtablissements();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-2">
                    <h5 className="card-header">Liste des Etablissements <Link className="btn btn-primary btn-sm"
                        to={myroutes.etablissements_create} title="Ajouter">
                        <FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link></h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">N°</th>
                                    <th className="cell text-white">Etablissement </th>
                                    <th className="cell text-white">Dirigeant</th>
                                    <th className="cell text-white">Adresse</th>
                                    <th className="cell text-white">Site web</th>
                                    <th className="cell text-white">Téléphone</th>
                                    <th className="cell text-white">Email</th>
                                    <th className="cell text-white">Date modification</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {etablissements.length > 0 && etablissements.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.raisonsocialeEtablissement} </td>
                                        <td className="cell">{item.dirigeantEtablissement} </td>
                                        <td className="cell">{item.adresseEtablissement} </td>
                                        <td className="cell">{item.siteWeb} </td>
                                        <td className="cell">{item.telephoneprimaireEtablissement} </td>
                                        <td className="cell">{item.emailEtablissement} </td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <div className="d-flex">
                                            <Button
                                            className="btn btn-sm rounded-5"
                                            variant="success"
                                            onClick={() => handleDetails(item.id)}
                                            title="Détails"
                                        >
                                            <FontAwesomeIcon icon="fa-solid fa-list" />
                                        </Button>
                                        &nbsp;&nbsp;
                                                <EditButton action={() => goToEdit(item.id)}></EditButton>&nbsp;&nbsp;
                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)} title="Supprimer">
                                                    <i className="fas fa-trash"></i></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}
            </div>

            <>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title className="text-white">
                Détails d'un étalissement
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form className="needs-validation" noValidate >
                                    <div className="row">
                                    <div className="row mb-3">
                                            <div className="col-md-6">
                                            <img
                                                className="me-2"
                                                src="/images/logo_gs_sans_fond.png"
                                                alt=""
                                                style={{ width: "24%", textAlign: "center" }}
                                            />
                                            </div>
                                            <div className="col-md-6 mt-4">
                                            <div className="col-md-12 mb-3">
                                            <Badge bg="secondary fw-bold">
                                            {signatureEtablissement}
                                             </Badge>
                                        </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                            <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-raisonsocialeEtablissement">Nom Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-raisonsocialeEtablissement" type="text" value={raisonsocialeEtablissement} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="raisonsocialeEtablissement" />

                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-fondateurEtablissement">Fondateur<i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-fondateurEtablissement" type="text" value={fondateurEtablissement} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="fondateurEtablissement" />
                       
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-dirigeantEtablissement">Dirigeant <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-dirigeantEtablissement" type="text" value={dirigeantEtablissement} 
                                                placeholder="" maxLength={100} name="dirigeantEtablissement" />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-adresseEtablissement">Adresse Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-adresseEtablissement" type="text" value={adresseEtablissement} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="adresseEtablissement" />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephoneprimaireEtablissement">Telephone primaire Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-telephoneprimaireEtablissement" type="text" value={telephoneprimaireEtablissement} 
                                                placeholder="" required={true} maxLength={20} minLength={8} name="telephoneprimaireEtablissement" />                                            
                                          
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-telephonesecondaireEtablissement">Telephone secondaire Etablissement </Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-telephonesecondaireEtablissement" type="email" value={telephonesecondaireEtablissement} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="telephonesecondaireEtablissement" />
                                        </div>                    
                                        </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                            <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailEtablissement">Email Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-emailEtablissement" type="email" value={emailEtablissement} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="emailEtablissement" />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailsupportEtablissement">Email support Etablissement <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-emailsupportEtablissement" type="text" value={emailsupportEtablissement} 
                                                placeholder="" maxLength={100} name="emailsupportEtablissement"  />     
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-emailnotificationEtablissement">Email Notification Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-emailnotificationEtablissement" type="text" value={emailnotificationEtablissement} 
                                                placeholder="" maxLength={100} name="emailnotificationEtablissement" />   
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-sigleEtablissement">Sigle Etablissement <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-sigleEtablissement" type="text" value={sigleEtablissement} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="sigleEtablissement" />
                       
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-siteWeb">Site Web <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-siteWeb" type="text" value={siteWeb} 
                                                placeholder="" maxLength={100} name="siteWeb"  />     
                                        </div>
                                       
                                    <div className="col-md-12 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-boitePostale">Boite Postale <i className="text-danger"></i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-boitePostale" type="text" value={boitePostale} 
                                                placeholder="" required={true} maxLength={100} minLength={3} name="boitePostale" />
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button
                  variant="primary"
                  type="button"
                  onClick={() => goToEdit(idEtablissement)}
                >
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal.Body>
          </Modal>
        </>

        </Layout>
    )
}